'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactMove = require('react-move');

var _d3Ease = require('d3-ease');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CheckBox = function (_React$Component) {
  _inherits(CheckBox, _React$Component);

  function CheckBox() {
    _classCallCheck(this, CheckBox);

    return _possibleConstructorReturn(this, (CheckBox.__proto__ || Object.getPrototypeOf(CheckBox)).apply(this, arguments));
  }

  _createClass(CheckBox, [{
    key: 'GetCheckBoxStyle',
    value: function GetCheckBoxStyle() {
      return _extends({
        height: this.props.checkBoxStyle.size,
        width: this.props.checkBoxStyle.size,
        backgroundColor: "transparent",
        border: this.props.checkBoxStyle.size * 0.1 + ' solid ' + this.props.checkBoxStyle.unCheckedColor,
        borderRadius: "5px",
        borderStyle: "solid",
        borderWidth: this.props.checkBoxStyle.size * 0.1,
        position: "relative",
        display: "inline-block",
        boxSizing: "border-box",
        cursor: "pointer"
      }, this.props.style);
    }
  }, {
    key: 'GetAnimateStyle',
    value: function GetAnimateStyle() {
      if (this.props.checked) {
        return {
          borderColor: this.props.checkBoxStyle.checkedColor,
          beforeHeight: this.props.checkBoxStyle.size * 1.2,
          afterHeight: this.props.checkBoxStyle.size * 0.5
        };
      } else {
        return {
          borderColor: this.props.checkBoxStyle.unCheckedColor,
          beforeHeight: 0,
          afterHeight: 0
        };
      }
    }
  }, {
    key: 'GetBeforeStyle',
    value: function GetBeforeStyle() {
      return {
        boxSizing: "border-box",
        position: "absolute",
        width: this.props.checkBoxStyle.size * 0.2,
        backgroundColor: this.props.checkBoxStyle.checkedColor,
        display: "inline-block",
        transformOrigin: "left top",
        borderRadius: "5px",
        top: this.props.checkBoxStyle.size * 0.72,
        left: this.props.checkBoxStyle.size * 0.41,
        //boxShadow: `0 0 0 ${this.props.checkBoxStyle.size * 0.05} ${this.props.checkBoxStyle.backgroundColor}`,
        transform: "rotate(-135deg)"
      };
    }
  }, {
    key: 'GetAfterStyle',
    value: function GetAfterStyle() {
      return {
        boxSizing: "border-box",
        position: "absolute",
        width: this.props.checkBoxStyle.size * 0.2,
        backgroundColor: this.props.checkBoxStyle.checkedColor,
        display: "inline-block",
        transformOrigin: "left top",
        borderRadius: "5px",
        top: this.props.checkBoxStyle.size * 0.37,
        left: this.props.checkBoxStyle.size * 0.05,
        transform: "rotate(-45deg)"
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        _reactMove.Animate,
        {
          start: this.GetAnimateStyle(),
          update: function update() {
            var style = _this2.GetAnimateStyle();
            if (_this2.props.checked) {
              return [{
                borderColor: [style.borderColor],
                timing: {
                  ease: _d3Ease.easeQuadIn,
                  duration: _this2.props.duration / 2
                }
              }, {
                beforeHeight: [style.beforeHeight],
                timing: {
                  ease: _d3Ease.easeQuadIn,
                  duration: _this2.props.duration / 2,
                  delay: _this2.props.duration / 2
                }
              }, {
                afterHeight: [style.afterHeight],
                timing: {
                  ease: _d3Ease.easeQuadIn,
                  duration: _this2.props.duration / 2
                }
              }];
            } else {
              return [{
                borderColor: [style.borderColor],
                timing: {
                  ease: _d3Ease.easeQuadIn,
                  duration: _this2.props.duration / 2
                }
              }, {
                beforeHeight: [style.beforeHeight],
                afterHeight: [style.afterHeight],
                timing: {
                  duration: 0
                }
              }];
            }
          }
        },
        function (state) {
          return _react2.default.createElement(
            'label',
            {
              onClick: _this2.props.onClick,
              style: _extends({}, _this2.GetCheckBoxStyle(), { borderColor: state.borderColor })
            },
            _react2.default.createElement('div', { style: _extends({}, _this2.GetBeforeStyle(), { height: state.beforeHeight }) }),
            _react2.default.createElement('div', { style: _extends({}, _this2.GetAfterStyle(), { height: state.afterHeight }) })
          );
        }
      );
    }
  }]);

  return CheckBox;
}(_react2.default.Component);

exports.default = CheckBox;


CheckBox.propTypes = {
  checkBoxStyle: _propTypes2.default.shape({
    checkedColor: _propTypes2.default.string.isRequired,
    size: _propTypes2.default.number.isRequired,
    unCheckedColor: _propTypes2.default.string.isRequired
  }),
  checked: _propTypes2.default.bool.isRequired,
  duration: _propTypes2.default.number.isRequired,
  onClick: _propTypes2.default.func,
  style: _propTypes2.default.object
};